import API from '@/service/api'

const state = {
  filesEntries: [],
}

const mutations = {
  UPDATE_FILES_ENTRIES(state, payload) {
    state.filesEntries = payload
  },
}

const actions = {
  getFilesEntries({ commit }) {
    return API()
      .get('/upload/files')
      .then(response => {
        commit('UPDATE_FILES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },
  addFile({ commit }, payload, config) {
    return API()
      .post('/upload', payload, config)
      .then(response => {
        commit('UPDATE_FILES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },
  deleteFile({ commit }, id) {
    return API()
      .delete(`/upload/files/${id}`)
      .then(response => {
        commit('UPDATE_FILES_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },
}

const getters = {
  filesEntries: state => state.filesEntries,
}

const uploadModule = {
  state,
  mutations,
  actions,
  getters,
}

export default uploadModule
